document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-lumivelle-product]');
  if (!root) return;

  var form = root.querySelector('#LumivelleProductForm');
  var mainImage = root.querySelector('[data-main-image]');
  var previewName = root.querySelector('[data-preview-name]');
  var packageCards = Array.prototype.slice.call(root.querySelectorAll('[data-package]'));
  var colorCards = Array.prototype.slice.call(root.querySelectorAll('[data-color]'));
  var slots = Array.prototype.slice.call(root.querySelectorAll('[data-slot]'));
  var variantInput = root.querySelector('[data-variant-id]');
  var colorVariants = JSON.parse(root.querySelector('[data-color-variants]').textContent);
  var addButton = root.querySelector('[data-add-button]');
  var errorBox = root.querySelector('[data-form-error]');
  var heading = root.querySelector('[data-selection-heading]');
  var colorPrompt = root.querySelector('[data-color-prompt]');
  var selectedName = root.querySelector('[data-selected-name]');
  var properties = {
    single: root.querySelector('[data-property="single"]'),
    pair1: root.querySelector('[data-property="pair-1"]'),
    pair2: root.querySelector('[data-property="pair-2"]'),
    pair3: root.querySelector('[data-property="pair-3"]')
  };
  var state = { package: 'trio', activeSlot: 1, single: null, trio: [null, null, null], submitting: false };

  function activePackageCard() {
    return packageCards.find(function (card) { return card.dataset.package === state.package; });
  }

  function currentSelections() {
    return state.package === 'single' ? [state.single] : state.trio;
  }

  function selectedVariant() {
    var first = currentSelections()[0];
    if (!first) return null;
    var packageName = state.package === 'single' ? 'One Pair' : 'Trio Bundle';
    return colorVariants.find(function (variant) {
      return variant.option1 === packageName && variant.option2.toLowerCase() === first.code;
    });
  }

  function showPreview(selection) {
    if (!selection) return;
    mainImage.src = selection.image;
    mainImage.alt = selection.name;
    previewName.textContent = selection.name;
  }

  function updateProperties() {
    if (state.package === 'single') {
      properties.single.disabled = false;
      properties.single.value = state.single ? state.single.name : '';
      properties.pair1.disabled = true;
      properties.pair2.disabled = true;
      properties.pair3.disabled = true;
    } else {
      properties.single.disabled = true;
      properties.pair1.disabled = false;
      properties.pair2.disabled = false;
      properties.pair3.disabled = false;
      properties.pair1.value = state.trio[0] ? state.trio[0].name : '';
      properties.pair2.value = state.trio[1] ? state.trio[1].name : '';
      properties.pair3.value = state.trio[2] ? state.trio[2].name : '';
    }
  }

  function updateSlots() {
    var selections = currentSelections();
    slots.forEach(function (slot, index) {
      var visible = state.package === 'trio' || index === 0;
      var selection = selections[index];
      slot.hidden = !visible;
      slot.classList.toggle('active', visible && index === state.activeSlot - 1);
      slot.classList.toggle('filled', Boolean(selection));
      slot.setAttribute('aria-pressed', visible && index === state.activeSlot - 1 ? 'true' : 'false');
      if (!visible) return;
      var image = slot.querySelector('img');
      var name = slot.querySelector('.slot-name');
      var empty = slot.querySelector('.slot-empty');
      if (selection) {
        image.src = selection.image;
        image.alt = selection.name;
        image.hidden = false;
        name.textContent = selection.name.replace(/^C\d+\s*/, '');
        empty.hidden = true;
      } else {
        image.removeAttribute('src');
        image.alt = '';
        image.hidden = true;
        name.textContent = '';
        empty.hidden = false;
      }
    });
  }

  function updateColorCards() {
    var selection = currentSelections()[state.activeSlot - 1];
    colorCards.forEach(function (card) {
      var selected = Boolean(selection && selection.code === card.dataset.color);
      card.classList.toggle('selected', selected);
      card.setAttribute('aria-checked', selected ? 'true' : 'false');
    });
    selectedName.textContent = selection ? 'Selected: ' + selection.name : '16 colors available';
    colorPrompt.textContent = state.package === 'single' ? 'SELECT A COLOR' : 'SELECT COLOR FOR PAIR ' + state.activeSlot;
  }

  function updateButton() {
    var card = activePackageCard();
    var selections = currentSelections();
    var complete = selections.every(Boolean);
    var variant = selectedVariant();
    var available = variant ? variant.available : !selections[0] && card && card.dataset.available === 'true';
    addButton.disabled = !complete || !available || state.submitting;
    var colorHint = root.querySelector('[data-color-hint]');
    if (colorHint) {
      colorHint.hidden = complete;
      colorHint.textContent = state.package === 'single' ? 'Please select 1 color.' : 'Please select 3 colors.';
    }
    if (!available) {
      addButton.textContent = 'SOLD OUT';
    } else if (state.submitting) {
      addButton.textContent = 'ADDING TO CART…';
    } else if (!complete) {
      addButton.textContent = 'ADD TO CART';
    } else {
      addButton.textContent = state.package === 'single'
        ? 'ADD TO CART'
        : 'ADD TO CART';
    }
  }

  function render() {
    var card = activePackageCard();
    packageCards.forEach(function (item) {
      var selected = item === card;
      item.classList.toggle('selected', selected);
      item.setAttribute('aria-checked', selected ? 'true' : 'false');
    });
    var variant = selectedVariant();
    variantInput.value = variant ? variant.id : '';
    heading.textContent = state.package === 'single' ? 'YOUR PAIR' : 'YOUR THREE PAIRS';
    root.querySelector('[data-slots]').classList.toggle('single-package', state.package === 'single');
    updateSlots();
    updateColorCards();
    updateProperties();
    updateButton();
  }

  packageCards.forEach(function (card) {
    card.addEventListener('click', function () {
      state.package = card.dataset.package;
      state.activeSlot = 1;
      errorBox.hidden = true;
      var selection = currentSelections()[0];
      if (selection) showPreview(selection);
      render();
    });
  });

  slots.forEach(function (slot) {
    slot.addEventListener('click', function () {
      state.activeSlot = Number(slot.dataset.slot);
      var selection = currentSelections()[state.activeSlot - 1];
      if (selection) showPreview(selection);
      updateSlots();
      updateColorCards();
    });
  });

  colorCards.forEach(function (card) {
    card.addEventListener('click', function () {
      var selection = { code: card.dataset.color, name: card.dataset.name, image: card.dataset.image };
      if (state.package === 'single') {
        state.single = selection;
      } else {
        state.trio[state.activeSlot - 1] = selection;
      }
      showPreview(selection);
      errorBox.hidden = true;
      render();
      if (state.package === 'trio' && state.activeSlot < 3) {
        state.activeSlot += 1;
        updateSlots();
        updateColorCards();
      }
    });
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (addButton.disabled || state.submitting) return;
    state.submitting = true;
    errorBox.hidden = true;
    updateButton();

    var payload = new FormData(form);
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: payload
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Unable to add this item.'); });
      return response.json();
    }).then(function () {
      return fetch(window.Shopify.routes.root + 'cart.js').then(function (response) { return response.json(); });
    }).then(function (cart) {
      var count = document.querySelector('[data-cart-count]');
      if (count) count.textContent = cart.item_count;
      window.location.href = window.Shopify.routes.root + 'cart';
    }).catch(function (error) {
      state.submitting = false;
      errorBox.textContent = error.message;
      errorBox.hidden = false;
      updateButton();
    });
  });

  var requestedColor = new URLSearchParams(window.location.search).get('color');
  if (requestedColor) {
    var requestedCard = colorCards.find(function (card) { return card.dataset.color === requestedColor.toLowerCase(); });
    if (requestedCard) {
      var requestedSelection = { code: requestedCard.dataset.color, name: requestedCard.dataset.name, image: requestedCard.dataset.image };
      state.trio[0] = requestedSelection;
      showPreview(requestedSelection);
    }
  }

  render();
});
